"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Call = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#clip0_171_58830)"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M14.492 10.943A3.516 3.516 0 0111 14c-4.962 0-9-4.037-9-9a3.516 3.516 0 013.058-3.492 1 1 0 011.038.595l1.32 2.946v.008a1 1 0 01-.115.991L6 7.591c.468.95 1.463 1.937 2.427 2.407l1.521-1.295a1 1 0 01.995-.123l.008.004 2.945 1.32a1 1 0 01.596 1.039z",
  className: "fill"
})), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
  id: "clip0_171_58830"
}, /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M0 0h16v16H0z"
}))));

var _default = Call;
exports.default = _default;